<template>
  <div class="row">
    <!-- Total Cost -->
    <div class="col-lg">
      <card type="chart">
        <template slot="header">
          <h5 class="card-category">
            <div style="text-align: right">
              <base-button type="success" @click="addItem()">
                Add Item
                <i class="tim-icons icon-simple-add"></i>
              </base-button>
            </div>
            <!-- form row -->
            <tr>
              <td>
                <!-- if schedule type = cluster, display list of cluster-->
                <div class="col-md" id="type">
                  <!-- select which cluster to schedule -->
                  <base-input label="Cluster:">
                    <el-select
                      class="select-primary"
                      placeholder="Choose..."
                      size="large"
                      v-model="cluster"
                    >
                      <el-option
                        style="color: #000000"
                        v-for="option in selects.multicast"
                        class="select-primary"
                        :value="option.value"
                        :label="option.label"
                        :key="option.label"
                      ></el-option>
                    </el-select>
                  </base-input>
                </div>
              </td>
              <td>
                <div class="col-md" id="holidayName" style="color: #FFFFFFF">
                  <base-input
                    label="Holiday Name:"
                    v-model="holiday"
                    placeholder="Holiday Name"
                  ></base-input>
                </div>
              </td>
              <td>
                <div class="col-md" id="start">
                  <base-input label="Start:">
                    <el-date-picker
                      type="daterange"
                      v-model="date"
                      align="right"
                      unlink-panels
                      range-separator="To"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </base-input>
                </div>
              </td>
            </tr>

            <!-- scheduler table -->
            <div class="col-lg-12 col-md-6" style="padding-top: 10px">
              <h3 class="card-title brightness">
                <div>
                  <div
                    class="
                      col-12
                      d-flex
                      justify-content-center justify-content-sm-between
                      flex-wrap
                    "
                  ></div>
                  <el-table
                    :data="holidayTable"
                    :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
                  >
                    <el-table-column
                      min-width="150"
                      sortable
                      label="id"
                      property="id"
                    ></el-table-column>
                    <!-- cluster -->
                    <el-table-column
                      min-width="150"
                      sortable
                      label="Cluster"
                      property="cluster"
                    ></el-table-column>
                    <!-- holiday name-->
                    <el-table-column
                      min-width="150"
                      sortable
                      label="Holiday Name"
                      property="holiday"
                    ></el-table-column>
                    <!-- date -->
                    <el-table-column
                      :data="dateStartEnd"
                      min-width="150"
                      sortable
                      label="Date"
                      property="date"
                    ></el-table-column>
                  </el-table>
                </div>
              </h3>
            </div>

            <!-- submit scheduler -->
            <div id="button">
              <div id="button_container_1">
                <button
                  type="success"
                  class="btn btn-success"
                  @click="
                    submit(selects.scheType, selects.device, selects.multi)
                  "
                >
                  Submit
                </button>
              </div>
            </div>

            <!-- scheduler history -->
            <div class="col-lg-12 col-md-6" style="padding-top: 40px">
              <h3 class="card-title brightness">
                <div>
                  <div
                    class="
                      col-12
                      d-flex
                      justify-content-center justify-content-sm-between
                      flex-wrap
                    "
                  ></div>
                  <h2>Scheduler History</h2>
                  <el-table
                    :data="historyData"
                    :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
                  >
                    <el-table-column
                      min-width="150"
                      sortable
                      label="id"
                      property="id"
                    ></el-table-column>
                    <!-- Username -->
                    <el-table-column
                      min-width="150"
                      sortable
                      label="hour"
                      property="hour"
                    ></el-table-column>
                    <!-- Email -->
                    <el-table-column
                      min-width="150"
                      sortable
                      label="min"
                      property="min"
                    ></el-table-column>
                    <!-- Telephone -->
                    <el-table-column
                      min-width="150"
                      sortable
                      label="status"
                      property="status"
                    ></el-table-column>
                    <!-- Date created -->
                    <el-table-column
                      min-width="150"
                      sortable
                      label="brightness"
                      property="br"
                    ></el-table-column>
                  </el-table>
                </div>
              </h3>
            </div>
          </h5>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  TimeSelect,
  DatePicker,
  Select,
  Option,
} from "element-ui";
import { TabPane, Tabs } from "src/components";
import { Modal } from "src/components";
import swal from "sweetalert2";
import { set } from "d3";
// import { base64Value} from base64Value

export default {
  components: {
    TabPane,
    Tabs,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      cluster: "",
      holiday: "",
      date: "",
      tableColumns: [
        {
          prop: "cluster",
          label: "Cluster",
          // minWidth: 200
        },
        {
          prop: "holiday",
          label: "Holiday Name",
          // minWidth: 250
        },
        {
          prop: "date",
          label: "Date",
          // minWidth: 250
        },
      ],
      modals: {
        edit: false,
      },
      selects: {
        multicast: [],
        id: 0,
      },
      dateStartEnd: "",
      id: 0,
      hour: "",
      min: "",
      status: "",
      br: "",
      Hheader: "",
      Hprofile: "",
      Hhour: "",
      Hmin: "",
      Hstatus: "",
      Hbr: "",
      setHoliday: [],
      historyData: [],
      holidayTable: [],
      hexData: [],
      postData: [],
      getRowData: "",
      clusterName: "Cluster 1",
      sche: "Scheduler",
      multicast: null,
      devices: [],
    };
  },
  mounted() {
    console.log("TESTDDDDDD");
    this.getlist();
  },
  methods: {
    getlist() {
      // get list of clusters
      const arr = [];
      this.$http
        .get("https://alpha.vectolabs.com:8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {
            console.log(res.message);
          } else {
            let data = res.message.cluster_list;
            console.log("sssss " + data);
            this.multicast = data;
            console.log("multicast : " + this.multicast.length);
            // this.getListCluster(sT,this.multicast);
            this.selects.multicast = [];
            for (let i = 0; i < this.multicast.length; i++) {
              console.log("test");
              // console.log(this.multicast.clustername)
              let multicast_array = {
                value: this.multicast[i].multicastid,
                label: this.multicast[i].clustername,
              };
              console.log("multicast Array" + JSON.stringify(multicast_array));
              this.selects.multicast.push(multicast_array);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getRow(row) {
      this.getRowData = row;
    },
    edituser() {
      console.log("editedit");
    },
    submit(schedulerType, dev, multi) {
      console.log("hjhjhh " + schedulerType);
      console.log("device iddd: " + dev);
      console.log("multicast id: " + multi);
      // console.log(this.rowData.length + "hi")

      for (var i = 0; i < this.rowData.length; i++) {
        // console.log("test array" + i)
        // console.log(this.rowData[i])

        // set hex header
        var hexHead = 5;
        let hexHeader = ("0" + (hexHead & 0xff).toString(16)).slice(-2);
        console.log(hexHeader);

        // set hex profile (weekdays)
        var hexPro = 1;
        let hexProfile = ("0" + (hexPro & 0xff).toString(16)).slice(-2);
        console.log(hexProfile);

        // index
        var index = i;
        let hexIndex = ("0" + (index & 0xff).toString(16)).slice(-2);
        console.log("hexIndex " + hexIndex);

        // change hour to hex
        let hexHour = ("0" + (this.rowData[i].hour & 0xff).toString(16)).slice(
          -2
        );
        console.log(hexHour + " hour in hex");

        // change min to hex
        let hexMin = ("0" + (this.rowData[i].min & 0xff).toString(16)).slice(
          -2
        );
        console.log(hexMin + " min in hex");

        // set on/off status to hex
        if (this.rowData[i].status === "On") {
          var hexLampu = "0" + 1;
          console.log(hexLampu + " status Lampu ");
        } else {
          var hexLampu = "0" + 0;
          console.log(hexLampu + " status Lampu ");
        }

        // set brightness to hex
        if (this.rowData[i].br === 1) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 2) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 3) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 4) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 5) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 6) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 7) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 8) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 9) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else if (this.rowData[i].br === 10) {
          var hexBr = ("0" + (this.rowData[i].br & 0xff).toString(16)).slice(
            -2
          );
          console.log(hexBr + " brightness in hex");
        } else {
          console.log("Invalid Brightness");
        }

        var hexValue =
          hexHeader +
          hexProfile +
          hexIndex +
          hexHour +
          hexMin +
          hexLampu +
          hexBr;
        console.log(hexValue);

        // var base64Value = hexValue.toString('base64');

        var base64Value = btoa(
          String.fromCharCode.apply(
            null,
            hexValue
              .replace(/\r|\n/g, "")
              .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
              .replace(/ +$/, "")
              .split(" ")
          )
        );
        console.log("base64Value " + base64Value);

        var my_base64 = {
          base64Value: this.base64Value,
        };

        this.hexData.push(base64Value);
        // console.log("hex array: " + this.hexData)
      }
      console.log("hex array: " + JSON.stringify(this.hexData));

      // if hexdata empty pop up error and prevent sending
      if (this.hexData.length < 1) {
        swal({
          type: "error",
          title: "Oops... Array empty! Please insert some value",
          // text: res.message
        });
        preventDefault();
      } else {
        // send according to scheduler type(multicast/device)
        if (schedulerType === "multicast") {
          console.log("muticast id " + multi);
          // pass to PARAM
          var urlAPI =
            "https://alpha.vectolabs.com:8003/v1/api/control/light/multicast/" +
            multi;
          ("/false");
          console.log(urlAPI);
          this.postData = [];
          for (var i = 0; i < this.hexData.length; i++) {
            var param = this.hexData;
            console.log("hantar satu satu " + param);

            let data = {
              multicastQueueItem: {
                confirmed: false,
                fPort: 3,
                data: param,
                multicastGroupID: multi, //multicast id. nak tanya!!!
              },
            };
            this.postData.push(data);
            console.log("postData " + JSON.stringify(this.postData));

            // this.historyData.push(data);
            // console.log("history" + this.historyData)

            fetch(urlAPI, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              mode: "no-cors",
              body: JSON.stringify(this.postData),
            })
              .then((response) => {})
              .then((data) => {
                // console.log(data);
                // this.rowData = [];
                // this.multicast_array = []
                // this.selects.multicast = []

                // send value to return weekdays value
                // masuk dalam scheduler history table
                var urlAPI =
                  "https://alpha.vectolabs.com:8003/v1/api/control/light/multicast/" +
                  multi;
                ("/false");

                // data pull from API insert in array
                this.returnData = [];

                // value to send 07 + profile + read index (loop from 0 - 13)
                var hexHead = 7;
                let hexHeader = ("0" + (hexHead & 0xff).toString(16)).slice(-2);
                console.log(hexHeader);

                // set hex profile (weekdays)
                var hexPro = 1;
                let hexProfile = ("0" + (hexPro & 0xff).toString(16)).slice(-2);
                console.log(hexProfile);

                for (var i = 0; i < 14; i++) {
                  // index
                  var index = i;
                  let hexIndex = ("0" + (index & 0xff).toString(16)).slice(-2);
                  console.log("hexIndex " + hexIndex);
                }

                for (var i = 0; i < this.hexData.length; i++) {
                  var param = this.hexData;
                  console.log("hantar satu satu " + param);

                  let data = {
                    multicastQueueItem: {
                      confirmed: false,
                      fPort: 3,
                      data: param,
                      multicastGroupID: multi,
                    },
                  };

                  this.returnData.push(data);
                  console.log("postData " + JSON.stringify(this.postData));

                  fetch(urlAPI, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    mode: "no-cors",
                    body: JSON.stringify(this.postData),
                  })
                    .then((response) => {})
                    .then((data) => {});
                }

                this.postData = [];
                this.hexData = [];
                this.rowData = [];
              });
          }
        } else {
          console.log("deviceee id " + dev);
          // pass to PARAM
          var urlAPI =
            "https://alpha.vectolabs.com:8003/v1/api/control/light/unicast/" +
            dev;
          ("/false");
          console.log(urlAPI);
          this.postData = [];
          for (var i = 0; i < this.hexData.length; i++) {
            var param = this.hexData[i];
            console.log("hantar satu satu " + param);

            let data = {
              deviceQueueItem: {
                confirmed: false,
                fPort: 3,
                data: param,
                devEUI: dev, //device id. nak tanya!!!
              },
            };

            this.postData.push(data);
            console.log("postData " + JSON.stringify(this.postData));
            // this.historyData.push(data);

            // console.log("data " + JSON.stringify(data))
            fetch(urlAPI, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              mode: "no-cors",
              body: JSON.stringify(this.postData),
            })
              .then((response) => {})
              .then((data) => {
                // console.log(data);
                // this.Postdata = []
                // this.devices_array = []
                // this.selects.devices = []
                this.postData = [];
                this.hexData = [];
                this.rowData = [];
              });
          }
        }
      }
      // clear array
      this.rowData = [];
      this.postData = [];
      this.hexData = [];
      this.selects.id = 0;
      // console.log("clear array" + this.rowData)
    },
    addItem() {
      var my_object = {
        id: this.selects.id,
        cluster: this.cluster,
        holiday: this.holiday,
        date: this.date,
      };

      // checking empty form
      this.errors = [];

      if (!this.cluster) {
        swal({
          type: "error",
          title: "Please select cluster",
        });
        // this.errors.push("Hour is required");
      }

      if (!this.holiday) {
        swal({
          type: "error",
          title: "Please enter holidays name",
        });
        // this.errors.push("Hour is required");
      }

      if (!this.date) {
        swal({
          type: "error",
          title: "Please enter holidays date",
        });
        // this.errors.push("Min is required");
      }

      if (!this.cluster || !this.holiday || !this.date) {
        preventDefault();
      } else {
        this.setHoliday.push(my_object);
        console.log(this.setHoliday.length);
        console.log("set holidays" + JSON.stringify(this.setHoliday));
        for (var i = 0; i < this.setHoliday.length; i++) {
          console.log("hi" + JSON.stringify(this.setHoliday[i]));
          var myObject = {
            holidayName: this.setHoliday[i].holiday,
            startDate: this.setHoliday[i].date[0],
            endDate: this.setHoliday[i].date[1],
          };
          this.holidayTable.push(myObject);
          console.log("this holiday" + JSON.stringify(this.holidayTable));
          // for(var j=0; j<this.setholiday[i].date.length; j++){
          //   console.log("hiiiiiiiii")
          //   // var startDate = this.setHoliday[i].date[j]
          //   // var endDate = this.setHoliday[i].date[j+1]
          //   // var myObject = {
          //   //   cluster: this.setHoliday[i].cluster,
          //   //   holidayName: this.setHoliday[i].holiday,
          //   //   startdate: this.startDate,
          //   //   enddate: this.endDate
          //   // }
          //   // this.holidayTable.push(myObject)
          //   // console.log("holiday table" + holidayTable)
          // }
        }
        // if (this.rowData.length < 1) {
        //   this.rowData.push(my_object);
        // } else {
        //   if (this.rowData[this.rowData.length - 1].hour < this.selects.hour) {
        //     // console.log("dfdfgdfgfd" + this.rowData[length-1].hour)
        //     this.rowData.push(my_object);
        //   } else {
        //     // check minit
        //     if (this.rowData[this.rowData.length - 1].min < this.selects.min) {
        //       this.rowData.push(my_object);
        //     } else {
        //       swal({
        //         type: "error",
        //         title: "Error! Please enter bigger value than previous!"
        //       });
        //     }
        //   }

        // }

        // console.log(this.rowData);
        // this.selects.id = 1;
        // for (var i = 0; i < this.rowData.length; i++) {
        //   this.selects.id = this.rowData.length;
        //   console.log(this.selects.id);
        // }
        // this.selects.hour = "";
        // this.selects.min = "";
        // this.selects.simple = "";
        // this.selects.brightness = "";
      }
    },
  },
};
</script>

<style scoped>
.analytic el-select {
  display: inline;
}
.a h3 {
  display: inline;
}
</style>